import * as React from 'react';
import SvgIcon,{SvgIconProps} from '@mui/material/SvgIcon';
import {redDefault} from "app/components/ThemeProvider/colors";

const CloseIcon = ({sx,...props}: SvgIconProps) => {

    return(
        <SvgIcon viewBox="0 0 16 16" sx={{height:'16px' , width:'16px',...sx}} {...props}>
            <path d="M12 4L4 12M4 4L12 12" stroke={props.color === 'warning' ? redDefault : 'black'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </SvgIcon>
);
};

export default CloseIcon;

